import { render, staticRenderFns } from "./GraficoDashboard.vue?vue&type=template&id=2f0979da&scoped=true&"
import script from "./GraficoDashboard.vue?vue&type=script&lang=js&"
export * from "./GraficoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GraficoDashboard.vue?vue&type=style&index=0&id=2f0979da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0979da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
